import { api } from './config';

export interface BreachEntry {
  id: string;
  email: string;
  ip_address: string;
  username: string;
  password: string;
  hashed_password: string;
  name: string;
  vin: string;
  address: string;
  phone: string;
  database_name: string;
}

export interface BreachSearchResponse {
  balance: number;
  entries: BreachEntry[];
  success: boolean;
  took: string;
  total: number;
}

export async function searchDomainBreaches(domain: string): Promise<BreachSearchResponse> {
  try {
    const response = await api.get<BreachSearchResponse>(`/api/breach/search/domain/${encodeURIComponent(domain)}`);
    return response.data;
  } catch (error) {
    console.error('Error searching breaches:', error);
    return {
      balance: 0,
      entries: [],
      success: false,
      took: '',
      total: 0
    };
  }
}